import {IUser, UserLevel} from "shared/entities/user";
import {AuthService} from "@/services/auth";
import Component from "vue-class-component";
import {Vue} from "vue-property-decorator";

@Component
export default class AuthMixin extends Vue {
    protected get user(): IUser | null {
        if (AuthService.user) return AuthService.user;
        return null;
    }

    protected async created() {
        if (!AuthService.user) {
            await this.$router.push("/authorize");
        }
    }
}
